// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1vwqI","col":"Table_col__3zopV","fulfillmentStatus":"Table_fulfillmentStatus__2Mq_E","emailCol":"Table_emailCol__1CI6W"};